<template>
  <v-container fluid>
    <base-material-card id="card-rcp-data-table" color="primary" icon="$rcp" inline class="ml-0 mt-4 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">RCP</div>
      </template>
      <v-btn
        id="btn-novo-rcp"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('add')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo RCP
      </v-btn>
      <v-text-field
        id="rcp-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-rcp ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando RCP" />
      <v-divider class="mt-10" />
      <v-data-table
        class="rcp-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum RCP disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.data_base`]="{ item }">
          {{ item.data_base }}
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.ultima_execucao`]="{ item }">
          {{ item.ultima_execucao }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-rcp"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-menu v-if="canRunItem(item) || canDeleteItem(item)" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-rcp"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarRcp(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deleteRcp(dialogDeleteData.id)"
    >
      <template slot="title">Deletar RCP #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o RCP
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import RcpService from '@/services/RcpService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue')
    },
    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados', 'recharge'],

    data() {
      return {
        powerupService: RcpService,
        powerupEntityName: 'RCP',
        dialogDelete: false,
        dialogDeleteData: { id: undefined, nome: undefined },
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Data Base',
            value: 'data_base'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'ultima_execucao'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        rcps: [],
        downloadProgressData: {}
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      },

      deleteRcp(id) {
        RcpService.excluir(id)
          .then(() => {
            this.$toast.success('RCP excluido com sucesso.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao excluir RCP.', '', { position: 'topRight' });
          });

        this.dialogDelete = false;
      },

      executarRcp(id) {
        RcpService.executar(id)
          .then(() => {
            this.$emit('recharge');
            this.$toast.success('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao executar RCP.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .rcp-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .rcp-table table tr td:nth-child(6),
    .rcp-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-rcp {
      display: inline-block !important;
      padding-top: 0px !important;
      width: 148.48px !important;
    }
  }

  #card-rcp-data-table .v-card--material__heading {
    padding: 13px !important;
  }

  #card-rcp-data-table div div svg {
    height: 38px !important;
    width: 38px !important;
  }

  #card-rcp-data-table div div svg path {
    fill: #e93d1f !important;
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>